import { render, staticRenderFns } from "./PaymentGatewayEditForm.vue?vue&type=template&id=40cd91dc&scoped=true&"
import script from "./PaymentGatewayEditForm.vue?vue&type=script&lang=js&"
export * from "./PaymentGatewayEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd91dc",
  null
  
)

export default component.exports